import { logService, httpLogPlugin, prefixLogPlugin } from '@nsftx/seven-client-retail-utils'
import { SevenComponentsPlugin } from '@nsftx/seven-components'
import { createSevenIgamingPlatformPlugin } from '@nsftx/seven-client-retail-vue-sgp'
import { createIntegratorPlugin } from '@nsftx/seven-client-retail-vue-integrator'
import { createRetailSdkPlugin, vNxgRetailFormatNumber } from '@nsftx/seven-nxg-retail-vue-sdk'
import translationsPlugin from './plugins/translationsPlugin'

import { type Plugin, createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './ui/components/App.vue'
import router from './router'

const urlParams = new URLSearchParams(window.location.search)
const urlLogLevel = urlParams.get('logLevel')
const lsLogLevel = localStorage.getItem('st.logLevel')

if (import.meta.env.PROD) {
  // set log level -> query param -> local storage -> default INFO
  logService.setLogLevel(urlLogLevel?.toUpperCase() || lsLogLevel?.toUpperCase() || 'INFO')
  // register http plugin that sends logs to grape
  logService.registerPlugin(httpLogPlugin.apply, {
    apiUrl: import.meta.env.VITE_GRAPE_API_URL,
    user: import.meta.env.VITE_GRAPE_API_AUTH_USER,
    pass: import.meta.env.VITE_GRAPE_API_AUTH_PASS,
    appName: 'SSBT',
    channel: 'SSBT' // so grape accepts request, change later to ssbt
  })
}
// register log prefix plugin (always)
logService.registerPlugin(prefixLogPlugin.apply)

const app = createApp(App)

app.use(createPinia())
app.use(createRetailSdkPlugin({ channel: 'ssbt' }))
app.use(router)
app.use(translationsPlugin)
app.use(SevenComponentsPlugin as unknown as Plugin, { SCKeyboard: { bottom: '64px' } })
app.use(createSevenIgamingPlatformPlugin, {
  token: null,
  notificationService: {
    events: ['ng::balance-update', 'ng::slip-update']
  }
})
app.use(createIntegratorPlugin({ type: 'ssbt' }))

app.directive('nxg-retail-format-number', vNxgRetailFormatNumber)

app.mount('#app')
